import React, { memo, useState, useEffect } from 'react';
import Card from './reportCard';
import { Form } from 'antd';

import RichEditor from './richEditor';

const title = {
  32: 'ERP',
  33: 'CRM',
  34: 'HCM',
  35: 'Marketing Automation',
  36: 'SCM',
};
function ReportCardWithRisk({
  risk,
  containerClassName,
  hasEditButton,
  // handleRiskEdit,
  // handleRiskSave,
  isRiskEditng,
  seqNum,
  riskForm,
  optionLevel,
  answer,
  ...props
}) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    setCount(count + 1);
  }, [risk]);

  const textAreaHandler = () => {
    if (!isRiskEditng) {
      return Array.isArray(risk) ? (
        risk.map((riskItem, index) => (
          <div
            className={`execution-risk-text ${
              riskItem.seqNum === 35 && 'block-show'
            }`}
            key={index}
          >
            <span>{`${title[riskItem.seqNum]}:`} </span>
            <pre className={riskItem.seqNum === 35 && 'row-indentation'}>
              {/* {riskItem.text} */}
              <RichEditor
                readOnly={true}
                value={riskItem.text}
                autoSize={{ minRows: 3, maxRows: 3 }}
                style={{ resize: 'none' }}
                linkPopoverProps={{
                  placement: 'leftTop',
                }}
              />
            </pre>
          </div>
        ))
      ) : (
        // <pre>{risk}</pre>
        <RichEditor
          readOnly={count}
          value={risk}
          autoSize={{ minRows: 3, maxRows: 3 }}
          style={{ resize: 'none' }}
          linkPopoverProps={{
            placement: 'leftTop',
          }}
        />
      );
    } else if (isRiskEditng && !hasEditButton) {
      if (Array.isArray(risk)) {
        return risk.map((item, index) => (
          <Form.Item
            key={index}
            className="execution-risk-textarea"
            label={title[item.seqNum]}
            name={['risk', `${item.seqNum}--${item.level}`]}
            initialValue={item.text && item.text}
          >
            <RichEditor
              autoSize={{ minRows: 3, maxRows: 3 }}
              style={{ resize: 'none' }}
              maxLength={800}
              linkPopoverProps={{
                placement: 'leftTop',
              }}
            />
          </Form.Item>
        ));
      }
      return (
        <Form.Item
          name={['risk', `${seqNum}--${optionLevel}`]}
          initialValue={risk}
        >
          <RichEditor
            autoSize={{ minRows: 3 }}
            style={{ resize: 'none' }}
            maxLength={800}
            linkPopoverProps={{
              placement: 'leftTop',
            }}
          />
        </Form.Item>
      );
    }
  };

  return (
    <section
      className={`complexity-report-card-withrisk ${
        containerClassName ? containerClassName : ''
      }`}
    >
      <Card {...props} />
      <div className="risk-content">
        <div>
          {/*{hasEditButton && isInternal && (*/}
          {/*  <EditSaveBtn*/}
          {/*    editText="EDIT Risk Mitigation Strategy"*/}
          {/*    className="risk-edit"*/}
          {/*    handleSave={handleRiskSave}*/}
          {/*    handleEdit={handleRiskEdit}*/}
          {/*    isLoading={props.isRiskLoading}*/}
          {/*    isRiskEditng={isRiskEditng}*/}
          {/*  />*/}
          {/*)}*/}

          {textAreaHandler()}
        </div>
      </div>
    </section>
  );
}

ReportCardWithRisk.propTypes = {};

export default memo(ReportCardWithRisk);
